// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__EmNmJ","checkbox_placeholder":"Checkbox_checkbox_placeholder___XDZi","checkbox_selected":"Checkbox_checkbox_selected__f8RYE"};